import React from 'react'
import MainLayout from '../../layout/MainLayout'
import AddCommunity from '../../components/community/AddCommunity'

const AddCommunityPage = () => {
  return (
    <MainLayout>
        <AddCommunity />
    </MainLayout>
  )
}

export default AddCommunityPage